import { decryptData, encryptData } from "./helpers/encryptionDecryption";

const getStorer = (rememberMe) => {
  //return rememberMe ? localStorage : sessionStorage;
  return localStorage
};


const webTokenStorer = {
  saveToken: ({ access_token, society_id, house_unique_id, user_role, pwd = "", rememberMe, is_super_admin }) => {
    //const storer = getStorer(rememberMe);
    const storer = getStorer(true);
    const data = {
      access_token,
      society_id,
      house_unique_id,
      user_role,
      pwd,
      is_super_admin
    }
    storer.setItem("UserData", JSON.stringify(data))
  },
  saveToken2: ({ access_token, society_id, house_unique_id, user_role, pwd = "", rememberMe, is_super_admin }) => {
    //const storer = getStorer(rememberMe);
    const storer = getStorer(true);
    const data = {
      access_token,
      society_id,
      house_unique_id,
      user_role,
      pwd,
      is_super_admin
    }
    storer.setItem("AdminData", JSON.stringify(data))
  },

  removeToken: () => {
    localStorage.removeItem("UserData");
    localStorage.removeItem("AdminData");
    //sessionStorage.clear();
  },

  getToken: () => {
    const data = localStorage.getItem('UserData') || sessionStorage.getItem('UserData');
    if (data) {
      return JSON.parse(data)
    }
    return null;
  },

  // Decode the JWT payload to read the logged-in user's id (set on token issue in authController).
  getUserId: () => {
    try {
      const data = localStorage.getItem('UserData') || sessionStorage.getItem('UserData');
      if (!data) return null;
      const token = JSON.parse(data)?.access_token;
      if (!token || typeof token !== 'string') return null;
      const [, payload] = token.split('.');
      if (!payload) return null;
      const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
      return decoded?.user_id || null;
    } catch {
      return null;
    }
  },
  // Logged-in user's id for either session. The webmaster (SocietyController)
  // login lives under AdminData, so check it before UserData — getUserId()
  // above only reads UserData.
  getSessionUserId: () => {
    try {
      const raw = localStorage.getItem('AdminData') || localStorage.getItem('UserData');
      const token = raw ? JSON.parse(raw)?.access_token : null;
      const payload = typeof token === 'string' ? token.split('.')[1] : null;
      if (!payload) return null;
      return JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')))?.user_id ?? null;
    } catch {
      return null;
    }
  },

  getToken2: () => {
    const data = localStorage.getItem('AdminData') || sessionStorage.getItem('AdminData');
    if (data) {
      return JSON.parse(data)
    }
    return null;
  },

  // checkRememberMe: () => {
  //   return localStorage.getItem('UserData') ? true : false;
  // },
};

export const webCredentialsStorer = {

  saveCredentials: ({ id, pwd }) => {
    const data = {
      id,
      pwd
    }
    localStorage.setItem("EGv_hy", encryptData(data))
  },

  removeCredentials: () => {
    localStorage.removeItem("EGv_hy")
  },

  getCredentials: () => {
    try {
      const data = localStorage.getItem('EGv_hy');
      if (data) {
        return decryptData(data)
      }
      return null;
    } catch (error) {
      console.log(error)
      localStorage.removeItem("EGv_hy")
    }
  },
};

// Selected Society Storage
export const selectedSocietyStorer = {
  saveSociety: (society) => {
    if (society) {
      localStorage.setItem("SelectedUserSociety", JSON.stringify(society));
    }
  },

  getSociety: () => {
    const data = localStorage.getItem('SelectedUserSociety');
    if (data) {
      return JSON.parse(data);
    }
    return null;
  },

  removeSociety: () => {
    localStorage.removeItem("SelectedUserSociety");
  },

  getSocietyId: () => {
    // Primary — the explicitly-chosen society (set on society picker screens).
    const data = localStorage.getItem('SelectedUserSociety');
    if (data) {
      try {
        const societyId = JSON.parse(data)?.society_id;
        if (societyId) return societyId;
      } catch { /* fall through to fallback */ }
    }
    // Fallback — single-society users may never hit the picker, but their
    // login response already stamped a society_id into UserData. Reading it
    // here avoids null-society payloads when the picker was skipped.
    const userData = localStorage.getItem('UserData') || sessionStorage.getItem('UserData');
    if (userData) {
      try {
        return JSON.parse(userData)?.society_id || null;
      } catch { /* ignore */ }
    }
    return null;
  },

  // Role of the selected membership (role switch). Rows from /auth/me carry it
  // as role.role_id, rows from /user-societies/my-societies as role_id.
  getRoleId: () => {
    const data = localStorage.getItem('SelectedUserSociety');
    if (!data) return null;
    try {
      const sel = JSON.parse(data);
      return sel?.role?.role_id ?? sel?.role_id ?? null;
    } catch {
      return null;
    }
  },

  // Get user_society_id for API calls (unique identifier for user's role in society)
  getUserSocietyId: () => {
    const data = localStorage.getItem('SelectedUserSociety');
    if (data) {
      const userSocietyData = JSON.parse(data);
      return userSocietyData?.user_society_id || null;
    }
    return null;
  },
  getUserSocietydata: () => {
    const data = localStorage.getItem('SelectedUserSociety');
    if (data) {
      const userSocietyData = JSON.parse(data);
      return userSocietyData;
    }
    return null;
  }
};

export default webTokenStorer;

